const packageName = "@atlassian/switcher";
const packageVersion = "31.2.1";
export default {
  packageName,
  packageVersion
};